import React from 'react'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'
import { withRouter } from 'react-router-dom'
import { Modal, Button } from 'semantic-ui-react'
import { SUGGESTED_CONDITIONS_QUERY } from '.'

const DenyModal = props => (
  <Modal
    size="small"
    style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: 100 }}
    trigger={<Button negative>Deny</Button>}
  >
    <Modal.Header>Deny Condition Request</Modal.Header>
    <Modal.Content>
      <Modal.Description>
        <p>{props.condition.name}</p>
        <p>Are you sure you want to deny this condition suggestion?</p>
      </Modal.Description>
    </Modal.Content>
    <Modal.Actions>
      <Mutation
        mutation={DENY_CONDITION}
        refetchQueries={[
          {
            query: SUGGESTED_CONDITIONS_QUERY,
            variables: {
              limit: 50,
              offset: 0,
            },
          },
        ]}
      >
        {denyCondition => {
          return (
            <Button
              negative
              onClick={async () => {
                await denyCondition({ variables: { id: props.condition.id } })
                props.history.push('/conditions')
              }}
            >
              Yes, Deny Request
            </Button>
          )
        }}
      </Mutation>
    </Modal.Actions>
  </Modal>
)

const DENY_CONDITION = gql`
  mutation DenyCondition($id: ID!) {
    denyCondition(id: $id) {
      id
    }
  }
`

export default withRouter(DenyModal)
